var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_64",
    "data-name": "Komponente 10 \\u2013 64",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.351,
    height: 67.997,
    viewBox: "0 0 46.351 67.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "water-drop",
    transform: "translate(-16.615 -0.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46771",
    "data-name": "Pfad 46771",
    d: "M27.52,57.032a18.334,18.334,0,0,0,6.952,1.3A19.668,19.668,0,0,0,47.4,53.523c3.119-2.729,7.862-9.031,4.808-20.271C51.04,28.9,48.766,25,46.622,21.3,43.309,15.579,39.93,9.732,40,1.675a1.378,1.378,0,0,0-.78-1.234,1.543,1.543,0,0,0-1.494.195C25.636,11.226,14.591,30.458,16.93,44.3A16.469,16.469,0,0,0,27.52,57.032ZM37.461,4.664c.65,7.277,3.833,12.735,6.887,18,2.144,3.768,4.223,7.277,5.328,11.305,1.949,7.277.52,13.449-4.028,17.543A17.173,17.173,0,0,1,28.56,54.5a13.308,13.308,0,0,1-8.771-10.72C17.71,31.887,27,14.865,37.461,4.664Z",
    transform: "translate(0)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46773",
    "data-name": "Pfad 46773",
    d: "M55.51,68.473a1.249,1.249,0,0,1-.78-.26,8.888,8.888,0,0,1-3.963-9.1,1.364,1.364,0,1,1,2.664.585,6.142,6.142,0,0,0,2.794,6.367,1.36,1.36,0,0,1,.325,1.884,1.18,1.18,0,0,1-1.04.52Z",
    transform: "translate(-26.245 -20.213)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35564",
    "data-name": "Gruppe 35564",
    transform: "translate(-331.035 -2892.671)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#a5b5af",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46717",
    "data-name": "Pfad 46717",
    d: "M23.5,6l-7.692,7.7L13.5,11.392",
    transform: "translate(360.5 2936.15)",
    fill: "none",
    stroke: "#a5b5af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/22.df6c767727f488ddccf3fac016a6c319.svg";
export { ForwardRef as ReactComponent };